(ns frontend.ui.page.lp-portal.report.view
  (:require
   [frontend.ui.page.lp-portal.report.style :as style]
   [frontend.ui.page.lp-portal.report.sub :as sub]
   [frontend.ui.page.lp-portal.home-link :as home-link]
   [frontend.ui.page.lp-portal.report.event :as event]
   [frontend.ui.component.grid.view :as grid]
   [frontend.ui.component.lp-portal.report.body.private-equity.fund.boxi.web.view :as boxi]
   [frontend.ui.component.lp-portal.report.body.private-equity.fund.buyout-x.web.view :as buyout]
   [frontend.ui.component.lp-portal.report.body.private-equity.fund.buyout-x-v2.web.view :as buyout-v2]
   [frontend.ui.component.lp-portal.report.body.private-equity.fund.infra.web.view :as infra]
   [frontend.ui.component.lp-portal.report.body.private-equity.fund.credit.web.view :as credit]
   [frontend.ui.component.lp-portal.report.body.private-equity.fund.credit-v2.web.view :as credit-v2]
   [frontend.ui.component.lp-portal.report.body.private-equity.fund.natural-capital.web.view :as natural-capital]

   [frontend.ui.component.lp-portal.report.body.real-estate.fund.nre.web.view.core :as nre-fund]
   [frontend.ui.component.lp-portal.report.body.real-estate.fund.hotel.web.view :as hotel]
   [frontend.ui.component.lp-portal.report.body.real-estate.fund.hotel-v2.web :as hotel-v2]
   [frontend.ui.component.lp-portal.report.body.real-estate.fund.koke.view :as koke]
   [frontend.ui.component.lp-portal.report.body.real-estate.fund.resi.view :as resi]
   [frontend.ui.component.lp-portal.report.body.real-estate.fund.resi-v2.web :as resi-v2]
   [frontend.ui.component.lp-portal.report.body.real-estate.fund.stockholm-living.view :as stockholm-living]

   [frontend.ui.component.lp-portal.report.body.feeder.endowment.web :as endowment]
   [frontend.ui.component.lp-portal.report.body.feeder.feeder.web :as feeder]

   [frontend.ui.component.lp-portal.report.body.invest-europe.fund.web :as invest-europe]

   [frontend.ui.component.lp-portal.report.body.voima.fund.web :as voima]
   [frontend.ui.component.lp-portal.report.body.voima.fund.pdf-pages.fund-overview :refer [empty-table-data?]]

   [frontend.ui.component.lp-portal.report.body.sparkmind.fund.web :as sparkmind]

   [frontend.ui.component.lp-portal.report.body.innovestor.fund.web :as innovestor]
   [frontend.ui.component.lp-portal.report.body.innovestor.holding.web :as innovestor-holding]

   [frontend.ui.component.lp-portal.report.body.lifeline.fund.web :as lifeline-fund]
   [frontend.ui.component.lp-portal.report.body.lifeline.fund.fund-v.web :as lifeline-fund-v]
   [frontend.ui.component.lp-portal.report.body.lifeline.fund.fund-vi.web :as lifeline-fund-vi]
   [frontend.ui.component.lp-portal.report.body.lifeline.holding.web :as lifeline-holding]

   [frontend.ui.component.lp-portal.report.body.private-equity.holding.company.web.view :as company]
   [frontend.ui.component.lp-portal.report.body.private-equity.holding.special-company.web.view :as
    special-company]
   [frontend.ui.component.lp-portal.report.body.private-equity.holding.company-exit.web.view :as
    company-exit]
   [frontend.ui.component.lp-portal.report.body.private-equity.holding.credit-company.view :as
    credit-company]
   [frontend.ui.component.lp-portal.report.body.private-equity.holding.infra-company.view :as
    infra-company]
   [frontend.ui.component.lp-portal.report.body.private-equity.holding.new-investment-company.view
    :as new-investment]

   [frontend.ui.component.lp-portal.report.body.real-estate.holding.property.view :as re-property]
   [frontend.ui.component.lp-portal.report.body.real-estate.holding.hotel.view :as hotel-holding]
   [frontend.ui.component.lp-portal.report.body.real-estate.holding.koke.view :as koke-holding]
   [frontend.ui.component.lp-portal.report.body.real-estate.holding.resi.view :as resi-holding]
   [frontend.ui.component.lp-portal.report.body.real-estate.holding.re-new-investment.view :as
    re-new-investment]
   [frontend.ui.component.lp-portal.report.body.real-estate.holding.re-exit-property.view :as
    re-exit-property]

   [frontend.ui.component.lp-portal.report.body.invest-europe.holding.web.holding :as ie-holding]
   [frontend.ui.component.lp-portal.report.body.invest-europe.holding.new-investment.web.view :as ie-new-investment]
   [frontend.ui.component.lp-portal.report.body.invest-europe.holding.exit.web.view :as ie-exit]

   [frontend.ui.component.lp-portal.report.body.sparkmind.holding.web :as sparkmind-holding]

   [common.localization :as loc]
   [herb.core :as h]
   [common.schema.entities.lp-portal.lp-report :as lp-report]
   [frontend.ui.component.lp-portal.footer.view :refer [footer]]
   [frontend.ui.component.lp-portal.header.view :refer [header]]
   [re-frame.core :as rf]
   [frontend.ui.component.lp-portal.modal.download-modal :as download-modal]
   [frontend.utils :as fu]
   [clojure.string :as s]))

(defn holding-report-content
  [{:keys [holding-template-type _holding-ui-data] :as props}]
  (case holding-template-type
    :lp-report-holding-template.capman/private-equity-company [company/company props]
    :lp-report-holding-template.capman/private-equity-special-situations [special-company/company
                                                                          props]
    :lp-report-holding-template.capman/credit-company [credit-company/credit-company props]
    :lp-report-holding-template.capman/infra-company [infra-company/infra-company props]
    :lp-report-holding-template.capman/private-equity-investment-company [new-investment/report
                                                                          props]
    :lp-report-holding-template.capman/natural-capital-investment [new-investment/dasos-report
                                                                   props]
    :lp-report-holding-template.capman/private-equity-exit-company [company-exit/company-exit props]

    :lp-report-holding-template.capman/real-estate-property-nre [re-property/property props]
    :lp-report-holding-template.capman/real-estate-property-nre-esg [re-property/property-esg props]
    :lp-report-holding-template.capman/real-estate-portfolio-nre-esg [re-property/portfolio-esg props]
    :lp-report-holding-template.capman/real-estate-portfolio-resi [resi-holding/resi props]
    :lp-report-holding-template.capman/real-estate-portfolio-resi-esg [resi-holding/portfolio-esg props]
    :lp-report-holding-template.capman/real-estate-property-resi-esg [resi-holding/property-esg props]
    :lp-report-holding-template.capman/real-estate-property-stockholm-living [resi-holding/stockholm-living props]
    :lp-report-holding-template.capman/real-estate-portfolio-koke [koke-holding/koke props]
    :lp-report-holding-template.capman/real-estate-portfolio-koke-esg [koke-holding/portfolio-esg props]
    :lp-report-holding-template.capman/real-estate-property-koke-esg [koke-holding/property-esg props]
    :lp-report-holding-template.capman/real-estate-portfolio-hotels [hotel-holding/hotel props]
    :lp-report-holding-template.capman/real-estate-portfolio-hotels-esg [hotel-holding/portfolio-esg props]
    :lp-report-holding-template.capman/real-estate-property-hotels-esg [hotel-holding/property-esg props]
    :lp-report-holding-template.capman/real-estate-new-investment [re-new-investment/view props]
    :lp-report-holding-template.capman/real-estate-exit-property [re-exit-property/view props]

    :lp-report-holding-template.invest-europe/holding [ie-holding/view props]
    :lp-report-holding-template.invest-europe/new-investment [ie-new-investment/new-investment props]
    :lp-report-holding-template.invest-europe/exit [ie-exit/exit props]

    :lp-report-holding-template.sparkmind/private-equity-company [sparkmind-holding/view props]

    :lp-report-holding-template.innovestor/holding [innovestor-holding/view props]
    :lp-report-holding-template.innovestor/technology-fund-holding [innovestor-holding/technology-holding-view props]
    :lp-report-holding-template.innovestor/technology-fund-holding-v2 [innovestor-holding/technology-holding-view props]
    :lp-report-holding-template.lifeline/holding [lifeline-holding/view props]
    :lp-report-holding-template.lifeline/exited-holding [lifeline-holding/view props]

    (str "Loading " holding-template-type " << " (type holding-template-type))))

(defn fund-report-content
  [{:keys [fund-template-type _report _fund-ui-data _edit-mode? _save-text] :as props}]
  (case fund-template-type
    :lp-report-template/materials-only [:div (loc/tr "Materials only")]
    :lp-report-template.capman/private-equity-fund-buyout-x [buyout/buyout-x props]
    :lp-report-template.capman/private-equity-fund-buyout-x-v2 [buyout-v2/buyout-x props]
    :lp-report-template.capman/private-equity-fund-boxi [boxi/boxi props]
    :lp-report-template.capman/infra-fund [infra/infra props]
    :lp-report-template.capman/credit-fund [credit/fund-credit props]
    :lp-report-template.capman/credit-fund-v2 [credit-v2/fund-credit props]
    :lp-report-template.capman/credit-fund-v2-capman [credit-v2/fund-credit props]
    :lp-report-template.capman/credit-fund-v3 [credit-v2/fund-credit-v3 props]
    :lp-report-template.capman/dasos-natural-capital [natural-capital/natural-capital-view (merge {:hide-footnote? true} props)]
    :lp-report-template.capman/dasos-natural-capital-FIN [natural-capital/natural-capital-view (merge {:hide-footnote? true
                                                                                                       :language :FI} props)]

    :lp-report-template.capman/real-estate-fund-hotels [hotel/hotel props]
    :lp-report-template.capman/real-estate-fund-hotels-v2 [hotel-v2/view props]
    :lp-report-template.capman/real-estate-fund-hotels-v3 [hotel-v2/view-v3 props]
    :lp-report-template.capman/real-estate-fund-koke [koke/koke props]
    :lp-report-template.capman/real-estate-fund-nre [nre-fund/real-estate-body props]
    :lp-report-template.capman/real-estate-fund-resi [resi/resi props]
    :lp-report-template.capman/real-estate-fund-resi-v2 [resi-v2/view props]
    :lp-report-template.capman/real-estate-fund-stockholm-living [stockholm-living/view props]

    :lp-report-template.capman/feeder-fund [feeder/feeder props]
    :lp-report-template.capman/endowment-fund [endowment/endowment props]

    ;; invest europe
    :lp-report-template.invest-europe/fund [invest-europe/report-view props]

    ;; voima ventures
    :lp-report-template.voima/fund [voima/report-view props]

    ;;sparkmind
    :lp-report-template.sparkmind/fund [sparkmind/report-view props]

    ;;innovestor
    :lp-report-template.innovestor/fund [innovestor/report-view props]
    :lp-report-template.innovestor/feeder-fund [innovestor/feeder-view props]
    :lp-report-template.innovestor/technology-fund [innovestor/tech-fund-report-view props]
    :lp-report-template.innovestor/technology-fund-v2 [innovestor/tech-fund-report-view props]

    :lp-report-template.lifeline/fund [lifeline-fund/view props]
    :lp-report-template.lifeline/fund-v [lifeline-fund-v/view props]
    :lp-report-template.lifeline/fund-vi [lifeline-fund-vi/view props]

    (str "Template not registered : " (get lp-report/hardcoded-fund-templates fund-template-type))))

(defn last-content
  [{:keys [fund-template-type _report _fund-ui-data _edit-mode? _save-text] :as props}]
  (case fund-template-type
    :lp-report-template.sparkmind/fund [sparkmind/after-holdings-view props]
    nil))

(defn fund-section-links
  [fund-template-type report-id fund-ui-data]
  (let [hide-table-link? (fn [data section key]
                           (some->> data
                                    section
                                    key
                                    :figures
                                    :data
                                    (remove nil?)
                                    (empty?)))
        sections (case fund-template-type
                   :lp-report-template/materials-only nil
                   :lp-report-template.capman/private-equity-fund-buyout-x
                   ["tearsheet"
                    "overview"
                    "esg"
                    "details-and-figures"
                    "investors"]
                   :lp-report-template.capman/private-equity-fund-buyout-x-v2
                   ["tearsheet"
                    "overview"
                    "esg"
                    "details-and-figures"
                    "investors"]
                   :lp-report-template.capman/private-equity-fund-boxi
                   (remove nil?
                           ["tearsheet"
                            "overview"
                            "esg"
                            "details-and-figures"
                            "investors"
                            "fee-summaries"
                            (when-not (and (hide-table-link? fund-ui-data :summaries :finance-summary)
                                           (hide-table-link? fund-ui-data :summaries :finance-summary-2))
                              "finance-summary")])
                   :lp-report-template.capman/infra-fund
                   (remove nil?
                           ["tearsheet"
                            "overview"
                            "esg"
                            "details-and-figures"
                            "investors"
                            (when-not (and (hide-table-link? fund-ui-data :summaries :finance-summary)
                                           (hide-table-link? fund-ui-data :summaries :finance-summary-2))
                              "finance-summary")])

                   :lp-report-template.capman/credit-fund
                   ["tearsheet"
                    "overview"
                    ;"esg"
                    "details-and-figures"
                    "investors"]
                   :lp-report-template.capman/credit-fund-v2
                   ["tearsheet"
                    "overview"
                    "esg"
                    "details-and-figures"
                    "investors"]
                   :lp-report-template.capman/credit-fund-v2-capman
                   ["tearsheet"
                    "overview"
                    "esg"
                    "details-and-figures"
                    "investors"]
                   :lp-report-template.capman/credit-fund-v3
                   ["tearsheet"
                    "overview"
                    "market-outlook"
                    "esg"
                    "details-and-figures"
                    "investors"]
                   :lp-report-template.capman/real-estate-fund-hotels
                   ["tearsheet"
                    "overview"
                    "debt-financing"
                    "esg"
                    "details-and-figures"
                    "financial-statements"]
                   :lp-report-template.capman/real-estate-fund-hotels-v2
                   []
                   :lp-report-template.capman/real-estate-fund-hotels-v3
                   []
                   :lp-report-template.capman/real-estate-fund-koke
                   ["tearsheet"
                    "overview"
                    "financial-performance"
                    "debt-financing"
                    "esg"
                    "details-and-figures"
                    "financial-statements"
                    "risk-assessment"]
                   :lp-report-template.capman/real-estate-fund-nre
                   ["tearsheet"
                    "overview"
                    "esg"
                    "details-and-figures"
                    "debt-financing"
                    "financial-statements"]
                   :lp-report-template.capman/real-estate-fund-resi
                   ["tearsheet"
                    "overview"
                    "inrev-nav"
                    "debt-financing"
                    "esg"
                    "details-and-figures"
                    "financial-statements"]
                   :lp-report-template.capman/real-estate-fund-resi-v2
                   []
                   :lp-report-template.capman/real-estate-fund-stockholm-living
                   ["tearsheet"
                    "overview"
                    "inrev-nav"
                    "debt-financing"
                    "details-and-figures"
                    "financial-statements"]
                   :lp-report-template.capman/feeder-fund nil
                   :lp-report-template.capman/endowment-fund nil
                   :lp-report-template.voima/fund
                   (remove nil?
                           ["overview" ;;TODO maybe add a better solution for hiding sections
                            "executive-summary"
                            "fund-overview"
                            (when-not (empty-table-data? (:portfolio-information fund-ui-data) :portfolio-summary)
                              "portfolio-information")
                            (when-not
                             (empty-table-data?
                              (:investor-information fund-ui-data)
                              :capital-account-since-inception)
                              (empty-table-data?
                               (:investor-information fund-ui-data)
                               :capital-account-year-to-date)
                              "investor-information")])
                   :lp-report-template.sparkmind/fund
                   (remove nil?
                           [;;TODO maybe add a better solution for hiding sections
                            "fund-overview"
                            (when-not (empty-table-data? (:portfolio-information fund-ui-data) :portfolio-summary)
                              "portfolio-information")])
                   :lp-report-template.innovestor/fund ["team-letter"
                                                        "fund-overview"
                                                        "esg"
                                                        "finance-summary"
                                                        "portfolio-information"]
                   :lp-report-template.innovestor/feeder-fund ["fund-overview"
                                                               "finance-summary"]
                   :lp-report-template.innovestor/technology-fund ["team-letter"
                                                                   "fund-overview-tech"
                                                                   "finance-summary"
                                                                   "portfolio-information"]
                   :lp-report-template.innovestor/technology-fund-v2 ["team-letter"
                                                                      "fund-overview-tech"
                                                                      "finance-summary"
                                                                      "portfolio-information"]
                   :lp-report-template.lifeline/fund ["fund-overview"
                                                      "portfolio-information"
                                                      "investors"
                                                      "capital-accounts"
                                                      "cash-flows-and-fees"]
                   :lp-report-template.lifeline/fund-v ["fund-overview"
                                                        "portfolio-information"
                                                        "investors"
                                                        "capital-accounts"
                                                        "cash-flows-and-fees"]
                   :lp-report-template.lifeline/fund-vi ["fund-overview"
                                                         "portfolio-information"
                                                         "investors"
                                                         "capital-accounts"
                                                         "cash-flows-and-fees"]
                   nil)]
    (->> sections
         (map
          (fn [s]
            {:link-id (str s "-" report-id)
             :label
             (case s
               "tearsheet" (loc/tr :tearsheet)
               "team-letter" (loc/tr :team-letter)
               "overview" (loc/tr :overview)
               "market-outlook" (loc/tr :market-outlook)
               "details-and-figures" (loc/tr :details-and-figures)
               "inrev-nav" (loc/tr :inrev-nav)
               "debt-financing" (loc/tr :debt-financing)
               "esg" (loc/tr :sustainability)
               "investors" (loc/tr :investors)
               "fee-summaries" (loc/tr :fee-summaries)
               "finance-summary" (loc/tr :finance-summary)
               "financial-statements" (loc/tr :financial-statements)
               "risk-assessment" (loc/tr :risk-assessment)
               "financial-performance" (loc/tr :financial-performance)
               "executive-summary" (loc/tr :executive-summary)
               "fund-overview" (loc/tr :fund-overview)
               "fund-overview-tech" (loc/tr :fund-overview)
               "portfolio-information" (loc/tr :portfolio-information)
               "investor-information" (loc/tr :investor-information)
               "capital-accounts" (loc/tr :capital-accounts)
               "cash-flows-and-fees" (loc/tr :cash-flows-and-fees)
               (str s))})))))

(defn last-section-links
  [fund-template-type report-id fund-ui-data]
  (let [sections (case fund-template-type
                   :lp-report-template.sparkmind/fund
                   (remove nil?
                           [(when-not
                             (and (empty-table-data?
                                   (:investor-information fund-ui-data)
                                   :capital-account-since-inception)
                                  (empty-table-data?
                                   (:investor-information fund-ui-data)
                                   :capital-account-year-to-date))
                              "investor-information")
                            "fees-interest-expenses"])
                   nil)]
    (->> sections
         (map
          (fn [s]
            {:link-id (str s "-" report-id)
             :label
             (case s
               "tearsheet" (loc/tr :tearsheet)
               "overview" (loc/tr :overview)
               "details-and-figures" (loc/tr :details-and-figures)
               "esg" (loc/tr :sustainability)
               "investors" (loc/tr :investors)
               "fee-summaries" (loc/tr :fee-summaries)
               "finance-summary" (loc/tr :finance-summary)
               "financial-statements" (loc/tr :financial-statements)
               "risk-assessment" (loc/tr :risk-assessment)
               "financial-performance" (loc/tr :financial-performance)
               "executive-summary" (loc/tr :executive-summary)
               "fund-overview" (loc/tr :fund-overview)
               "portfolio-information" (loc/tr :portfolio-information)
               "investor-information" (loc/tr :investor-information)
               "fees-interest-expenses" "GP fees, carried interest and fund operating expenses"
               (str s))})))))

(defn report-navigation
  [{:keys [fund-template-type report fund-ui-data holding-templates] :as _props}]
  (let [report-materials @(rf/subscribe [::sub/materials])
        accessible-investor-attachments @(rf/subscribe [::sub/accessible-investor-attachments])
        materials (->> report-materials
                       (map (fn [attachment]
                              {:id    (:db/id attachment)
                               :label (:attachment-filename attachment)}))
                       (sort-by :label)
                       (vec))]
    [:div
     (->> (concat (fund-section-links fund-template-type (:db/id report) fund-ui-data)
                  (->> holding-templates
                       (map (fn [[_template-type ui-data]]
                              {:link-id (str "holding-report-" (:report-id ui-data))
                               :label
                               (:holding-name ui-data)})))
                  (last-section-links fund-template-type (:db/id report) fund-ui-data))
          (map (fn [{:keys [link-id label]}]
                 ^{:key link-id}
                 [:div
                  {}
                  [:a
                   {:class    (h/<class style/sidebar-nav-link)
                    :on-click (fn [_]
                                (.scrollIntoView (js/document.getElementById link-id)
                                                 (clj->js {:behavior "smooth"})))
                    :href     (str "#" link-id)}
                   label]]))
          (doall))
     (when-not (and (empty? report-materials)
                    (empty? accessible-investor-attachments))
       [:div
        [:h2
         {:class (h/<class style/sidebar-attachments)}
         "Attachments: "]
        [:div
         (->> materials
              (map (fn [attachment]
                     ^{:key (str (:id attachment))}
                     [:div
                      {:class    (h/<class style/sidebar-attachment-item)
                       :on-click #(rf/dispatch [::event/download-items (:db/id report) [(:id attachment)]])}
                      [:span [:i.fal.fa-file-alt.mr-1] (:label attachment)]]))
              doall)
         (->> accessible-investor-attachments
              (map (fn [attachment]
                     ^{:key (str (:id attachment))}
                     [:div
                      {:class    (h/<class style/sidebar-attachment-item)
                       :on-click #(rf/dispatch [::event/download-private-material (:db/id report) (:id attachment)])}
                      [:span [:i.fal.fa-file-alt.mr-1] (:label attachment)]]))
              doall)]])]))

(defn download-modal
  [report]
  (let [report-materials @(rf/subscribe [::sub/materials])
        materials (->> report-materials
                       (map (fn [attachment]
                              {:id    (:db/id attachment)
                               :label (:attachment-filename attachment)}))
                       (sort-by :label)
                       (vec))
        no-source-data? (= :lp-report-template/materials-only
                           (:lp-report/template-type report))
        accessible-investor-attachments @(rf/subscribe [::sub/accessible-investor-attachments])
        export-formats @(rf/subscribe [::sub/export-formats])]
    [download-modal/view
     {:hide!           #(rf/dispatch [::event/close-download])
      :download!       #(rf/dispatch [::event/download-items (:db/id report) %])
      :visible?        true
      :export-formats  export-formats
      :fund-pdfs       [{:label (loc/tr :pdf-report)
                         :id    :fund-report}]
      :holding-reports nil
      :no-source-data? no-source-data?
      :source-data     (when-not no-source-data?
                         [{:label (loc/tr :fund-data)
                           :id    :full-data-set}])
      :materials       materials
      :private-materials accessible-investor-attachments}]))

(defn report-title
  [fund-ui-data props]
  (let [materials-only? (= (:fund-template-type props) :lp-report-template/materials-only)
        materials-only-data (->> props
                                 :report
                                 :lp-report/data)
        data (if materials-only?
               materials-only-data
               fund-ui-data)]
    [:div
     {:class (h/<class style/report-toolbar-title)}
     (:fund-name data)
     (when (or fund-ui-data materials-only-data)
       [:span {:style {:opacity 0.6}} " - "
        (-> data
            :reference-date
            (fu/format-date-ts "." true))])]))

(defn landscape-recommendation
  []
  [:div {:class (h/<class style/landscape-recommendation)}
   [:i.fal.fa-sync {:class (h/<class style/landscape-recommendation-icon)}]
   [:div
    {:class (h/<class style/landscape-recommendation-text)}
    (loc/tr :landscape-recommendation)]])

(defn report-toolbar
  [{:keys [_fund-template-type report fund-ui-data _holding-templates] :as props}]
  [:div
   {:style {:display :flex :flex-direction :column}}
   [:div {:style {:align-items "center" :display "flex" :justify-content "space-between"}}
    [:div
     {:class (h/<class style/hide-desktop)}
     [home-link/home-link]]
    [:div {:class (h/<class style/report-title-desktop)}
     [report-title fund-ui-data props]]
    [:div
     [:div
      {:class    (h/<class style/report-toolbar-download)
       :on-click #(rf/dispatch [::event/start-download])}
      (loc/tr :download)
      [:i.fas.fa-arrow-to-bottom.pl-2]]
     (when @(rf/subscribe [::sub/show-download?])
       [download-modal report])]]
   [:div {:class (h/<class style/report-title-mobile)} [report-title fund-ui-data]]
   [landscape-recommendation]])

(defn report-content
  [{:keys [fund-template-type _report fund-ui-data holding-templates] :as props}]
  [:div
   [:div
    {:class (h/<class style/spacing-top)}
    [grid/container {}
     [grid/row {}
      [grid/column {:large 12}
       (when (and fund-ui-data
                  fund-template-type)
         [fund-report-content props])]]]]
   (->> holding-templates
        (map (fn [[template-type ui-data]]
               ^{:key (str "report-review-holding-report-" (:report-id ui-data))}
               [grid/container {}
                [grid/row {}
                 [grid/column {:large 0}]
                 [grid/column {:large 12}
                  [holding-report-content
                   {:holding-template-type template-type
                    :holding-ui-data       ui-data
                    :fund-ui-data          fund-ui-data}]]]]))
        (doall))
   [:div
    {:class (h/<class style/spacing-top)}
    [grid/container {}
     [grid/row {}
      [grid/column {:large 12}
       (when (and fund-ui-data
                  fund-template-type)
         [last-content props])]]]]])

(defn report-view
  [props]
  [:div {:class (h/<class style/report-container)}
   ;; top sticky controls
   [:div {:class (h/<class style/report-toolbar)}
    [report-toolbar props]]

   ;; scrollable report content
   [:div {:class (h/<class style/report-content)}
    [:div {:class (h/<class style/scroll-container)}
     [report-content props]]]])

(defn materials-only-view
  [props]
  (let [burned-pdf-files @(rf/subscribe [::sub/burned-pdfs])
        pdf-files @(rf/subscribe [::sub/materials])
        first-pdf (or (some->> burned-pdf-files
                               (first))
                      (some->> pdf-files
                               (filter (fn [{:keys [attachment-filename]}]
                                         (when attachment-filename
                                           (s/ends-with? attachment-filename ".pdf"))))
                               (first)))]
    [:div {:class (h/<class style/report-container)}
     ;; top sticky controls
     [:div {:class (h/<class style/report-toolbar)}
      [report-toolbar
       (assoc props
              :home-link
              home-link/home-link)]]
     [:div
      {:class (h/<class style/embedded-pdf-container)}
      (when first-pdf
        [:iframe
         {:width  "100%"
          :height "100%"
          :src    (str "/js/pdfjs/web/viewer.html"
                       "?showOpenFileButton=false"
                       "&file=/attachment/api/download?file-id="
                       (:db/id first-pdf))}])]]))

(defn report
  [{:keys [fund-template-type report _fund-ui-data _holding-templates] :as props}]
  ^{:key (:db/id report)}
  [:div
   {:class (h/<class style/page-container)}
   [header]
   [:div
    {:class (h/<class style/page-content)}
    [:div
     {:class (h/<class style/page-content-inner)}
     ;; left column - don't scroll with page ??
     [:div {:class (h/<class style/left-container)}
      [:div {:class (h/<class style/toolbar-left)}
       [:div {:class (h/<class style/home-link-container)}
        [home-link/home-link]]
       [:div {:class (h/<class style/links-container)}
        [report-navigation props]]]]

     (if (or (= :lp-report-template/materials-only fund-template-type)
             (= :lp-report-template.capman/real-estate-fund-resi-v2 fund-template-type)
             (= :lp-report-template.capman/real-estate-fund-hotels-v2 fund-template-type)
             (= :lp-report-template.capman/real-estate-fund-hotels-v3 fund-template-type))
       [materials-only-view props]
       [report-view props])]]
   [footer]])
